import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { getPhoneCode } from '@/api/user';
export default {
  props: {
    accountInfo: {
      type: Object,
      default: () => ({})
    },
    way: {
      type: String,
      default: 'updatePhone'
    }
  },
  data() {
    return {
      form: {
        mobile: '',
        code: '',
        globalRoaming: '+86'
      },
      globalRoamingOptionData: [{
        label: '+86',
        value: '中国大陆',
        code: 'CN'
      }, {
        label: '+886',
        value: '中国台湾',
        code: 'TW'
      }, {
        label: '+852',
        value: '中国香港',
        code: 'HK'
      }, {
        label: '+853',
        value: '中国澳门',
        code: 'MO'
      }, {
        label: '+1',
        value: '美国',
        code: 'US'
      }, {
        label: '+65',
        value: '新加坡',
        code: 'SG'
      }],
      count: 60,
      disabledSendCode: false,
      text: '获取验证码',
      timer: null,
      time: 60,
      disable: false
    };
  },
  computed: {
    rules() {
      return {
        mobile: [{
          required: true,
          validator: this.checkMobile,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: this.$t('请输入') + this.$t('验证码'),
          trigger: 'blur'
        }, {
          pattern: /^\d{6}$/,
          message: this.$t('请输入') + this.$t('正确的') + this.$t('验证码'),
          trigger: 'blur'
        }]
      };
    },
    textLength() {
      return this.$t(this.text).length;
    }
  },
  mounted() {},
  methods: {
    checkMobile(rule, value, callback) {
      const regMap = {
        CN: /^1[3456789]\d{9}$/,
        // 中国
        TW: /^09\d{8}$/,
        // 台湾
        HK: /^([6|9])\d{7}$/,
        // 香港
        MO: /^[6]\d{7}$/,
        // 澳门
        US: /^[1-9]\d{9}$/,
        // 美国10位数字
        SG: /^[89]\d{7}$/ // 新加坡8或9开头，总长度为8位数字
      };
      let findItem = this.globalRoamingOptionData.find(item => item.label === this.form.globalRoaming);
      if (findItem && findItem.length === 0) {
        callback();
      }
      let regValue = regMap[findItem.code];
      // 判断为空时
      if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('新手机号')));
      } else if (!regValue.test(value)) {
        callback(new Error(this.$t('手机号码格式有误，请重新填写')));
      } else {
        callback();
      }
    },
    handleBlurTrim(key) {
      this.form[key] = this.form[key].trim();
    },
    codeInput(key, e) {
      var _e$target$value;
      this.form[key] = (_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.replace(/[^0-9]/g, '');
    },
    changeGlobalRoaming(value) {
      this.$set(this.form, 'mobile', '');
    },
    // 获取验证码
    getCode() {
      if (this.form.mobile) {
        getPhoneCode({
          mobile: this.form.mobile,
          way: this.way,
          globalRoaming: this.form.globalRoaming
        }).then(res => {
          this.verifyCodeInterval();
        });
      }
    },
    verifyCodeInterval() {
      this.text = `${this.time}s`;
      this.disable = true;
      this.timer = setInterval(() => {
        this.time--;
        this.text = `${this.time}s`;
        if (this.time === 0) {
          clearInterval(this.timer);
          this.text = '重新发送';
          this.time = 60;
          this.disable = false;
        }
      }, 1000);
      this.$refs.code.focus();
    }
  }
};